/** @flow */
// My Absences
export const GetMyAbsences = "GET_MY_ABSENCES";
export const GetMyAbsencesSuccess = "GET_MY_ABSENCES_SUCCESS";
export const GetMyAbsencesError = "GET_MY_ABSENCES_ERROR";

export const GetMyAbsencesSchema = "GET_MY_ABSENCES_SCHEMA";
export const GetMyAbsencesSchemaSuccess = "GET_MY_ABSENCES_SCHEMA_SUCCESS";
export const GetMyAbsencesSchemaError = "GET_MY_ABSENCES_SCHEMA_ERROR";

export const GetMyClassificationsSchema = "GET_MY_CLASSIFICATIONS_SCHEMA";
export const GetMyClassificationsSchemaSuccess = "GET_MY_CLASSIFICATIONS_SCHEMA_SUCCESS";
export const GetMyClassificationsSchemaError = "GET_MY_CLASSIFICATIONS_SCHEMA_ERROR";

export const SetShowAddMyAbsencesModal = "SET_SHOW_ADD_MY_ABSENCES_MODAL";
export const SetShowCloseMyAbsencesModal = "SET_SHOW_CLOSE_MY_ABSENCES_MODAL";
export const SetShowReOpenMyAbsencesModal = "SET_SHOW_RE_OPEN_MY_ABSENCES_MODAL";
export const SetShowCancelMyAbsencesModal = "SET_SHOW_CANCEL_MY_ABSENCES_MODAL";
export const SetMyAbsenceDraft = "SET_MY_ABSENCE_DRAFT";
export const GetUserActiveShiftPattern = "GET_USER_ACTIVE_SHIFT_PATTERN";
export const GetUserActiveShiftPatternSuccess = "GET_USER_ACTIVE_SHIFT_PATTERN_SUCCESS";
export const GetUserActiveShiftPatternError = "GET_USER_ACTIVE_SHIFT_PATTERN_ERROR";

export const CreateMyAbsence = "CREATE_MY_ABSENCE";
export const CreateMyAbsenceSuccess = "CREATE_MY_ABSENCE_SUCCESS";
export const CreateMyAbsenceError = "CREATE_MY_ABSENCE_ERROR";

export const SetAbsenceStatus = "SET_ABSENCE_STATUS";
export const SetAbsenceStatusSuccess = "SET_ABSENCE_STATUS_SUCCESS";
export const SetAbsenceStatusError = "SET_ABSENCE_STATUS_ERROR";

export const GetMyStandardQuestions = "GET_MY_STANDARD_QUESTIONS";
export const GetMyStandardQuestionsSuccess = "GET_MY_STANDARD_QUESTIONS_SUCCESS";
export const GetMyStandardQuestionsError = "GET_MY_STANDARD_QUESTIONS_ERROR";
export const AddMyStandardQuestions = "ADD_MY_STANDARD_QUESTIONS";
export const AddMyStandardQuestionsSuccess = "ADD_MY_STANDARD_QUESTIONS_SUCCESS";
export const AddMyStandardQuestionsError = "ADD_MY_STANDARD_QUESTIONS_ERROR";

export const GetMyDynamicQuestions = "GET_MY_DYNAMIC_QUESTIONS";
export const GetMyDynamicQuestionsSuccess = "GET_MY_DYNAMIC_QUESTIONS_SUCCESS";
export const GetMyDynamicQuestionsError = "GET_MY_DYNAMIC_QUESTIONS_ERROR";
export const AddMyDynamicQuestions = "ADD_MY_DYNAMIC_QUESTIONS";
export const AddMyDynamicQuestionsSuccess = "ADD_MY_DYNAMIC_QUESTIONS_SUCCESS";
export const AddMyDynamicQuestionsError = "ADD_MY_DYNAMIC_QUESTIONS_ERROR";

export const GetMyReferralQuestions = "GET_MY_REFERRAL_QUESTIONS";
export const GetMyReferralQuestionsSuccess = "GET_MY_REFERRAL_QUESTIONS_SUCCESS";
export const GetMyReferralQuestionsError = "GET_MY_REFERRAL_QUESTIONS_ERROR";
export const AddMyReferralQuestions = "ADD_MY_REFERRAL_QUESTIONS";
export const AddMyReferralQuestionsSuccess = "ADD_MY_REFERRAL_QUESTIONS_SUCCESS";
export const AddMyReferralQuestionsError = "ADD_MY_REFERRAL_QUESTIONS_ERROR";
export const AddMyAdditionalInfoQuestion = "ADD_MY_ADDITIONAL_INFO_QUESTION";
export const AddMyAdditionalInfoQuestionSuccess = "ADD_MY_ADDITIONAL_INFO_QUESTION_SUCCESS";
export const AddMyAdditionalInfoQuestionError = "ADD_MY_ADDITIONAL_INFO_QUESTION_ERROR";
export const GetMyAbsenceDaysLost = "GET_MY_ABSENCE_DAYS_LOST";
export const GetMyAbsenceDaysLostSuccess = "GET_MY_ABSENCE_DAYS_LOST_SUCCESS";
export const GetMyAbsenceDaysLostError = "GET_MY_ABSENCE_DAYS_LOST_ERROR";
export const UpdateMyAbsence = "UPDATE_MY_ABSENCE";
export const UpdateMyAbsenceSuccess = "UPDATE_MY_ABSENCE_SUCCESS";
export const UpdateMyAbsenceError = "UPDATE_MY_ABSENCE_ERROR";

export const GetMyAbsence = "GET_MY_ABSENCE";
export const GetMyAbsenceSuccess = "GET_MY_ABSENCE_SUCCESS";
export const GetMyAbsenceError = "GET_MY_ABSENCE_ERROR";

export const SetMyCurrentAbsence = "SET_MY_CURRENT_ABSENCE";

export const ExportMyAbsences = "EXPORT_MY_ABSENCES";
export const ExportMyAbsencesSuccess = "EXPORT_MY_ABSENCES_SUCCESS";
export const ExportMyAbsencesError = "EXPORT_MY_ABSENCES_ERROR";

export const GetCanOpenAbsence = "GET_CAN_OPEN_ABSENCE";
export const GetCanOpenAbsenceSuccess = "GET_CAN_OPEN_ABSENCE_SUCCESS";

// My Details
export const ChangePassword = "CHANGE_PASSWORD";
export const ChangePasswordSuccess = "CHANGE_PASSWORD_SUCCESS";
export const ChangePasswordError = "CHANGE_PASSWORD_ERROR";
export const GetContactInfoSchema = "GET_CONTACT_INFO_SCHEMA";
export const GetContactInfoSchemaSuccess = "GET_CONTACT_INFO_SCHEMA_SUCCESS";
export const GetContactInfoSchemaError = "GET_CONTACT_INFO_SCHEMA_ERROR";

export const GetMyDetails = "GET_MY_DETAILS";
export const GetMyDetailsSuccess = "GET_MY_DETAILS_SUCCESS";
export const GetMyDetailsError = "GET_MY_DETAILS_ERROR";
export const UpdateContactInfo = "UPDATE_CONTACT_INFO";
export const UpdateContactInfoSuccess = "UPDATE_CONTACT_INFO_SUCCESS";
export const UpdateContactInfoError = "UPDATE_CONTACT_INFO_ERROR";
export const ToggleContactInfoModal = "TOGGLE_CONTACT_INFO_MODAL";
export const ToggleHomePageSettingsModal = "TOGGLE_HOME_PAGE_SETTINGS_MODAL";
export const ToggleChangePasswordModal = "TOGGLE_CHANGE_PASSWORD_MODAL";
export const ToggleAbsenceDetailsModal = "TOGGLE_ABSENCE_DETAILS_MODAL";

// My Absence Stage
export const GetMonitoringHistory = "GET_MONITORING_HISTORY";
export const GetMonitoringHistorySuccess = "GET_MONITORING_HISTORY_SUCCESS";
export const GetMonitoringHistoryError = "GET_MONITORING_HISTORY_ERROR";
export const GetCurrentMonitoringStage = "GET_CURRENT_MONITORING_STAGE";
export const GetCurrentMonitoringStageSuccess = "GET_CURRENT_MONITORING_STAGE_SUCCESS";
export const GetCurrentMonitoringStageError = "GET_CURRENT_MONITORING_STAGE_ERROR";

// My Employees
export const GetNotificationContacts = "GET_NOTIFICATION_CONTACTS";
export const GetNotificationContactsSuccess = "GET_NOTIFICATION_CONTACTS_SUCCESS";
export const GetNotificationContactsError = "GET_NOTIFICATION_CONTACTS_ERROR";
export const SetNotificationContactsSelectedEmployeeId =
  "SET_NOTIFICATION_CONTACTS_SELECTED_EMPLOYEE_ID";

// Advice Library
export const GetAdviceLibraryCategories = "GET_ADVICE_LIBRARY_CATEGORIES";
export const GetAdviceLibraryCategoriesSuccess = "GET_ADVICE_LIBRARY_CATEGORIES_SUCCESS";
export const GetAdviceLibraryCategoriesError = "GET_ADVICE_LIBRARY_CATEGORIES_ERROR";
export const GetAdviceLibraryTopic = "GET_ADVICE_LIBRARY_TOPIC";
export const GetAdviceLibraryTopicSuccess = "GET_ADVICE_LIBRARY_TOPIC_SUCCESS";
export const GetAdviceLibraryTopicError = "GET_ADVICE_LIBRARY_TOPIC_ERROR";
export const ResetAdviceLibraryTopic = "RESET_ADVICE_LIBRARY_TOPIC";

// Service Directory
export const GetServiceDirectoryCategories = "GET_SERVICE_DIRECTORY_CATEGORIES";
export const GetServiceDirectoryCategoriesSuccess = "GET_SERVICE_DIRECTORY_CATEGORIES_SUCCESS";
export const GetServiceDirectoryCategoriesError = "GET_SERVICE_DIRECTORY_CATEGORIES_ERROR";
export const GetServiceDirectorySubCategories = "GET_SERVICE_DIRECTORY_SUBCATEGORIES";
export const ResetServiceDirectoryCategories = "RESET_SERVICE_DIRECTORY_CATEGORIES";
export const GetServiceDirectorySubCategoriesSuccess =
  "GET_SERVICE_DIRECTORY_SUBCATEGORIES_SUCCESS";
export const GetServiceDirectorySubCategoriesError = "GET_SERVICE_DIRECTORY_SUBCATEGORIES_ERROR";
export const GetServiceDirectoryTopicViewRequest = "GET_SERVICE_DIRECTORY_TOPIC_VIEW_REQUEST";
export const GetServiceDirectoryTopicViewRequestError =
  "GET_SERVICE_DIRECTORY_TOPIC_VIEW_REQUEST_ERROR";

// Service Desk
export const GetServiceDeskIssueTypes = "GET_SERVICE_DESK_ISSUE_TYPES";
export const GetServiceDeskIssueTypesSuccess = "GET_SERVICE_DESK_ISSUE_TYPES_SUCCESS";
export const GetServiceDeskIssueTypesError = "GET_SERVICE_DESK_ISSUE_TYPES_ERROR";
export const GetServiceDeskIssueFormData = "GET_SERVICE_DESK_ISSUE_FORM_DATA";
export const GetServiceDeskIssueFormDataSuccess = "GET_SERVICE_DESK_ISSUE_FORM_DATA_SUCCESS";
export const GetServiceDeskIssueFormDataError = "GET_SERVICE_DESK_ISSUE_FORM_DATA_ERROR";
export const ResetServiceDeskIssueFormData = "ResetServiceDeskIssueFormData";
export const AddServiceDeskIssue = "ADD_SERVICE_DESK_ISSUE";
export const AddServiceDeskIssueSuccess = "ADD_SERVICE_DESK_ISSUE_SUCCESS";
export const AddServiceDeskIssueError = "ADD_SERVICE_DESK_ISSUE_ERROR";
export const AddServiceDeskIssueAttachment = "ADD_SERVICE_DESK_ISSUE_ATTACHMENT";
export const AddServiceDeskIssueAttachmentSuccess = "ADD_SERVICE_DESK_ISSUE_ATTACHMENT_SUCCESS";
export const AddServiceDeskIssueAttachmentError = "ADD_SERVICE_DESK_ISSUE_ATTACHMENT_ERROR";
export const GetServiceDeskTickets = "GET_SERVICE_DESK_TICKETS";
export const GetServiceDeskTicketsSuccess = "GET_SERVICE_DESK_TICKETS_SUCCESS";
export const GetServiceDeskTicketsError = "GET_SERVICE_DESK_TICKETS_ERROR";
export const GetServiceDeskTicketContent = "GET_SERVICE_DESK_TICKET_CONTENT";
export const GetServiceDeskTicketContentSuccess = "GET_SERVICE_DESK_TICKET_CONTENT_SUCCESS";
export const GetServiceDeskTicketContentError = "GET_SERVICE_DESK_TICKET_CONTENT_ERROR";
export const ResetServiceDeskTicketContent = "RESET_SERVICE_DESK_TICKET_CONTENT";
